// You can use CONSTANTS.js file for below definitions of constants and import here.
import moment from "moment";
import { push } from "react-router-redux";
import { saveAs } from "file-saver";
import callApi from "../../Api";
import { ToastMessage, SUCCESS, ERROR } from "../../common/ToastMessage";
import { paymentDetailsFormatter } from "./paymentAction";
import { APPORVED, CHEQUE, PAYMENT_PENDING ,PER_PAGE} from "../../components/constants";
export const SET_CLASS_GROUPS = "SET_CLASS_GROUPS";
export const SET_BRANCHES = "SET_BRANCHES";
export const SET_SECTIONS = "SET_SECTIONS";
export const SET_PAYMENT_STATUSES = "SET_PAYMENT_STATUSES";
export const SET_LANGUAGES = "SET_LANGUAGES";
export const SET_STUDENT_DATA = "SET_STUDENT_DATA";
export const RESET_STUDENT_DATA = "RESET_STUDENT_DATA";
export const SET_REGISTRATION_PENDING_STUDENTS = "SET_REGISTRATION_PENDING_STUDENTS"
export const SET_STUDENTS_LIST = "SET_STUDENTS_LIST"
export const ASSIGN_CLASS_ROOM = "ASSIGN_CLASS_ROOM"
export const RESET_STUDENTS_LIST = "RESET_STUDENTS_LIST"
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const SET_PAYMENT_DUE_LIST = "SET_PAYMENT_DUE_LIST";
export const STATES_LIST = "STATES_LIST";
export const CLASS_ROOMS_LIST = "CLASS_ROOMS_LIST"
export const UPDATE_STUDENTS_LIST = "UPDATE_STUDENTS_LIST"
export const STUDENT_HISTORY = "STUDENT_HISTORY"
export const STUDENT_PAYMENT_HISTORY = "STUDENT_PAYMENT_HISTORY"
export const STUDENT_ADMISSION_FORWARD_CLASS_GROUPS ="STUDENT_ADMISSION_FORWARD_CLASS_GROUPS"
export const YEARS_LIST ="YEARS_LIST"
export const EMAIL_AVAILABILITY= "EMAIL_AVAILABILITY"
export const INSTALLMENTS_LIST = "INSTALLMENTS_LIST"
export const STUDENT_DUE_AMOUNT ="STUDENT_DUE_AMOUNT"
export const SET_BLOOD_GROUPS = "SET_BLOOD_GROUPS";
export const UPDATE_PER_PAGE = "UPDATE_PER_PAGE";
export const RESET_PAYMENT_DUE_LIST = "RESET_PAYMENT_DUE_LIST"
export const RESET_REGISTRATION_PENDING_STUDENTS = "RESET_REGISTRATION_PENDING_STUDENTS";
export const STUDENT_NOTIFICATION_LIST = "STUDENT_NOTIFICATION_LIST"
export const openLoader = (data) => ({
  type: OPEN_LOADER,
  payload: true,
});
export const closeLoader = (data) => ({
  type: CLOSE_LOADER,
  payload: false,
});

export const getClassGroups = (data) => ({
  type: SET_CLASS_GROUPS,
  payload: data,
});
export const getBranches = (data) => ({
  type: SET_BRANCHES,
  payload: data,
});
export const getSections = (data) => ({
  type: SET_SECTIONS,
  payload: data,
});
export const getPaymentStatuses = (data) => ({
  type: SET_PAYMENT_STATUSES,
  payload: data,
});
export const setLanguagesData = (data) => ({
  type: SET_LANGUAGES,
  payload: data,
});

export const setStudentData = (data) => ({
  type: SET_STUDENT_DATA,
  payload: data,
});

export const fetchRegistrationPendingAction = (data)=>({
    type: SET_REGISTRATION_PENDING_STUDENTS,
   payload: data,
  }
)

export const setStudentsData = (data)=>({
  
  type: SET_STUDENTS_LIST,
  payload: data,
})

export const setPaymentDue = (data) => ({
  type: SET_PAYMENT_DUE_LIST,
  payload: data,
});

const formatStudentDetails = (studentInfo)=>{
  if(studentInfo.hasOwnProperty("BranchClassGroup")){
    studentInfo.courseFee = parseInt(studentInfo.BranchClassGroup.fee);
    studentInfo.otherFee = 0;
    studentInfo.OtherFeeId = null;
    if(studentInfo.hasOwnProperty("OtherFees") && studentInfo.OtherFees.length > 0 ){
      studentInfo.otherFee =  parseInt(studentInfo.OtherFees[0].amount)
      studentInfo.OtherFeeId = studentInfo.OtherFees[0].id;
      studentInfo.totalFee = (studentInfo.courseFee + parseInt(studentInfo.OtherFees[0].amount))
    }else{
      studentInfo.totalFee = studentInfo.courseFee
    }
    const fatherData = studentInfo.guardian_info.filter(obj=> obj.gender === 'Male');
      const motherData = studentInfo.guardian_info.filter(obj=> obj.gender === 'Female');
    studentInfo.bio = {
      BranchName: studentInfo.Branch.name,
      ClassGroupName : studentInfo.Branch.name,
      ClassRoomName : studentInfo.ClassRoom ? studentInfo.ClassRoom.name : null ,
      location: studentInfo.Addresses.length > 0 ? studentInfo.Addresses[0].State.name : null  ,
      languages: studentInfo.User.language_info.map(obj=> obj.name).join(" , "),
      phoneNumber : studentInfo.User.phoneNumber,
      email : studentInfo.User.email,
      profileUrl : studentInfo.User.profileUrl,
      name: studentInfo.User.firstName + " " + studentInfo.User.lastName,
      dob : moment(studentInfo.dob).format("MMMM Do, YYYY"),
      dateOfJoin : moment(studentInfo.dateOfJoin).format("MMMM Do, YYYY"),
      fatherName: fatherData.length > 0 ? fatherData[0].name : null ,
      fatherMobileNumber: fatherData.length > 0 ? fatherData[0].phone : null,
      motherName: motherData.length > 0 ? motherData[0].name : null,
      motherMobileNumber: motherData.length > 0 ? motherData[0].phone : null
          

    }
    console.log(studentInfo.bio)
  }
  return studentInfo;
}

export const fetchClassGroups = (user) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("filter/classGroups");
    if (data.data.success) {
      dispatch(closeLoader());
      dispatch(getClassGroups(data.data.data));
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};


export const createStudent = (student) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/create",student);
    if (data.data.success) {
      dispatch(closeLoader());
      const studentInfo = formatStudentDetails({...data.data.data})
      dispatch(setStudentData(studentInfo));
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const fetchLanguages = () => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/languages");
    if (data.data.success) {
      dispatch(closeLoader());
      const languages = data.data.data.map(obj=> {
        return {
          value: obj.id,
          label: obj.name
        }
      })
      dispatch(setLanguagesData(languages));
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const createParents = (parentObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/createParentDetails",parentObj);
    if (data.data.success) {
      dispatch(closeLoader());
      const studentInfo = formatStudentDetails({...data.data.data})
      dispatch(setStudentData(studentInfo));
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const formatRegistrationPending =(data)=>{
  data.filter(studentObj=>{
    const fatherData = studentObj.guardian_info.filter(obj=> obj.gender === 'Male')
    const motherData = studentObj.guardian_info.filter(obj=> obj.gender === 'Female')
          studentObj.name = ((studentObj.User.firstName + " "+ studentObj.User.lastName) || '-');
          studentObj.email = studentObj.User.email;
          studentObj.phoneNumber = studentObj.User.phoneNumber;
          studentObj.BranchName = studentObj.Branch ? studentObj.Branch.name : '-';
          studentObj.ClassGroupName = studentObj.ClassGroup ? studentObj.ClassGroup.name : '-';
          studentObj.father_name =fatherData.length > 0 ? fatherData[0].name : '-';
          studentObj.father_phone = fatherData.length > 0 ? fatherData[0].phone : '-';
          studentObj.mother_name = motherData.length > 0 ? motherData[0].name : '-';
          studentObj.mother_phone = motherData.length > 0 ? motherData[0].phone : '-';
          studentObj.dateOfAssign = moment(studentObj.dateOfJoin).format("YYYY-MM-DD HH:MM:SS");
          // studentObj.classRoomName = studentObj.ClassRoom.name;
          studentObj.isPaymentCompleted = studentObj.StudentFees.length > 0 ? true : false; 
          // studentObj.isAssignClassPending = studentObj.StudentFees.length === 0 ? true : false;
  })
  return data;
}
export const fetchRegistrationPending = (filters) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/pendingRegistration",{params:filters});
    if (data.data.success) {
      dispatch(closeLoader());
      
      const rows = formatRegistrationPending(data.data.data.rows)
      
      dispatch(fetchRegistrationPendingAction({
        studentData: rows,
        totalPages: data.data.data.totalPages,
        currentPage: data.data.data.currentPage,
        totalItems: data.data.data.totalItems
      }));
      console.log("Update Requested",data)
      return data;
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const formatStudentsList = (data)=>{
  data.filter(studentBranchClassGroupRoomObj=>{
    const { Student,ClassRoom, ClassGroup } = studentBranchClassGroupRoomObj;
    const { User , guardian_info   } = Student;
    const fatherData = guardian_info.filter(obj=> obj.gender === 'Male')
    const motherData = guardian_info.filter(obj=> obj.gender === 'Female')
          studentBranchClassGroupRoomObj.name = ((User.firstName + " "+ User.lastName) || '-');
          studentBranchClassGroupRoomObj.email = User.email;
          studentBranchClassGroupRoomObj.ClassGroupName = ClassGroup.name;
          studentBranchClassGroupRoomObj.father_name =fatherData.length > 0 ? fatherData[0].name : '-';
          studentBranchClassGroupRoomObj.father_phone = fatherData.length > 0 ? fatherData[0].phone : '-';
          studentBranchClassGroupRoomObj.mother_name = motherData.length > 0 ? motherData[0].name : '-';
          studentBranchClassGroupRoomObj.mother_phone = motherData.length > 0 ? motherData[0].phone : '-';
          studentBranchClassGroupRoomObj.classRoomName = ClassRoom ? ClassRoom.name : '-'
          studentBranchClassGroupRoomObj.isAssignClassPending = ClassRoom ? false : true;
          studentBranchClassGroupRoomObj.BranchClassGroupId = Student.BranchClassGroupId
          studentBranchClassGroupRoomObj.gender = Student.gender ;
          studentBranchClassGroupRoomObj.dateOfAssign = moment(studentBranchClassGroupRoomObj.createdAt).format("YYYY-MM-DD") ;
          studentBranchClassGroupRoomObj.isPreviousHistory = !studentBranchClassGroupRoomObj.isActive
          studentBranchClassGroupRoomObj.thumbnail = User.profileUrl
          studentBranchClassGroupRoomObj.phoneNumber = User.phoneNumber
          studentBranchClassGroupRoomObj.dob = Student.dob;
          studentBranchClassGroupRoomObj.bloodGroup = Student.BloodGroupId;
          studentBranchClassGroupRoomObj.isInactiveStudent = !Student.isActive;
            
          console.log(studentBranchClassGroupRoomObj)

          // studentObj.dueAmount = 1000;
  })
  return data;
}

export const getStudentsListAction = (filters) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/list",{params:filters});
    if (data.data.success) {
      dispatch(closeLoader());
      const rows = formatStudentsList(data.data.data.rows);
      dispatch(setStudentsData({
        studentData: [...rows],
        totalItems: data.data.data.totalItems,
        totalPages: data.data.data.totalPages,
        currentPage: data.data.data.currentPage
      }));
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const studentProfileDetailsAction = (filters) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/profileDetails",{params:filters});
    if (data.data.success) {
      dispatch(closeLoader());
      const studentInfo = formatStudentDetails({...data.data.data})
      dispatch(setStudentData(studentInfo));
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const formatPaymentDueList = (data)=>{
  data.filter(studentBranchClassGroupRoomObj=>{
    const { StudentFee } = studentBranchClassGroupRoomObj;
    const { Student } = StudentFee;
    const { User , guardian_info , ClassRoom, ClassGroup  } = Student;
    const fatherData = guardian_info.filter(obj=> obj.gender === 'Male')
    const motherData = guardian_info.filter(obj=> obj.gender === 'Female')
    studentBranchClassGroupRoomObj.RegNo = studentBranchClassGroupRoomObj.RegNo;
    studentBranchClassGroupRoomObj.name = ((User.firstName + " " + User.lastName) || '-');
    studentBranchClassGroupRoomObj.email = User.email;
    studentBranchClassGroupRoomObj.phoneNumber = User.phoneNumber;
    studentBranchClassGroupRoomObj.ClassGroupName = ClassGroup.name;
    studentBranchClassGroupRoomObj.section = ClassRoom ? ClassRoom.name : "-"
    studentBranchClassGroupRoomObj.father_name =fatherData.length > 0 ? fatherData[0].name : '-';
    studentBranchClassGroupRoomObj.father_phone = fatherData.length > 0 ? fatherData[0].phone : '-';
    studentBranchClassGroupRoomObj.mother_name = motherData.length > 0 ? motherData[0].name : '-';
    studentBranchClassGroupRoomObj.mother_phone = motherData.length > 0 ? motherData[0].phone : '-';
    studentBranchClassGroupRoomObj.dueAmount = StudentFee.dueAmount;
    studentBranchClassGroupRoomObj.totalAmount = StudentFee.totalAmount + ( StudentFee.OtherFee ? StudentFee.OtherFee.amount : 0 );

    studentBranchClassGroupRoomObj.otherFee = (StudentFee.OtherFee ? StudentFee.OtherFee.amount : 0 );
    
    if(StudentFee.paidAmount === 0){
      studentBranchClassGroupRoomObj.totalAmount = StudentFee.totalAmount;
      studentBranchClassGroupRoomObj.isDiscountsEnabled = true;
      studentBranchClassGroupRoomObj.otherFee = ( StudentFee.OtherFee ? StudentFee.OtherFee.amount : 0 )
      studentBranchClassGroupRoomObj.totalFee = StudentFee.totalAmount + ( StudentFee.OtherFee ? StudentFee.OtherFee.amount : 0 )
      studentBranchClassGroupRoomObj.courseFee = StudentFee.totalAmount;
      studentBranchClassGroupRoomObj.dueAmount = ( StudentFee.dueAmount + ( StudentFee.OtherFee ? StudentFee.OtherFee.amount : 0 ) ) ;
    }else{
      studentBranchClassGroupRoomObj.totalFee = StudentFee.dueAmount;
      studentBranchClassGroupRoomObj.courseFee = StudentFee.dueAmount;
      if(StudentFee.OtherFee){
      if(StudentFee.OtherFee.PaymentStatus){
        if(StudentFee.OtherFee.PaymentStatus.status === PAYMENT_PENDING){
          studentBranchClassGroupRoomObj.dueAmount = ( StudentFee.dueAmount + ( StudentFee.OtherFee ? StudentFee.OtherFee.amount : 0 ) ) ;
        }
      }
    }
    }
    
    studentBranchClassGroupRoomObj.BranchClassGroup = {
            id: Student.BranchClassGroupId
          };
  })
  console.log(data)
  return data;
}

export const getPaymentDueListAction = (filters) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/paymentDue",{params:filters});
    if (data.data.success) {
      dispatch(closeLoader());
      const rows = formatPaymentDueList(data.data.data.rows);
      console.log(data.data.data.rows)
      dispatch(setPaymentDue({
        studentPaymentDue: rows,
        totalItems: data.data.data.totalItems,
        totalPages: data.data.data.totalPages,
        currentPage: data.data.data.currentPage
      }));
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const getStatesList = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/states");
    if (data.data.success) {
      dispatch(closeLoader());
      dispatch({
        type: STATES_LIST,
        payload: data.data.data.map(obj=>{
          return {
            value: obj.id,
            label: obj.name
          }
        }),
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const fetchClassRoomsAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/classRooms",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      const classRoomsList = data.data.data.filter(obj=>{
        obj.value = obj.ClassRoom.id;
        obj.label = obj.ClassRoom.name
        return obj;
      });
      dispatch({
        type: CLASS_ROOMS_LIST,
        payload: classRoomsList,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const assingClassRoomAction = (parentObj,studentList) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/assignClassRoom",parentObj);
    if (data.data.success) {
      const newData = []
      // const studentsData = studentList.filter(obj=> {
      //   if(obj.StudentId === parentObj.StudentId){
      //     obj.classRoomName = parentObj.classRoomName
      //     obj.ClassRoom = {name: parentObj.classRoomName}
      //     obj.ClassRoomId = parentObj.ClassRoomId
      //     obj.isAssignClassPending = false;
      //   }
      //   newData.push(obj)
      // return obj;
      // })
      dispatch(closeLoader());
      // dispatch({
      //   type: ASSIGN_CLASS_ROOM,
      //   payload: {
      //     studentData:[...newData]
      //   }
      // })
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const createNextYearAdmission = (parentObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/admissionForward",parentObj);
    if (data.data.success) {
      dispatch(closeLoader());
      dispatch(resetStudentDataAction())
      
      const studentData = formatStudentDetails({...data.data.data.profileDetails})
      let  studentInfo = {
        StudentFeeId : data.data.data.StudentFeeId,
        ...studentData
      }
     
      dispatch(setStudentData(studentInfo));
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const resetStudentDataAction = ()=> async (dispatch) => {
  dispatch({
    type: RESET_STUDENT_DATA,
    payload: {}
  })
}

export const sendMessageAction = (parentObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("notification/create",parentObj);
    if (data.data.success) {
      dispatch(closeLoader());
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const studentHistoryAction = (filters) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/studentHistory",{params:filters});
    if (data.data.success) {
      dispatch(closeLoader());
      const studentHistoryData = data.data.data.filter(obj=>{
        obj.BranchName = obj.Branch.name;
        obj.ClassGroupName = obj.ClassGroup.name;
        obj.ClassRoomName = obj.ClassRoom ? obj.ClassRoom.name : null;
        obj.academicStartDate = moment(obj.StudentFee.academicStartDate).format("YYYY-MM-DD")
        obj.academicEndDate = moment(obj.StudentFee.academicEndDate).format("YYYY-MM-DD")
        obj.courseAmount = obj.StudentFee.totalAmount;
        obj.dueAmount = obj.StudentFee.dueAmount;
        // obj.dueAmount = ( obj.StudentFee.dueAmount - (obj.StudentFee.discount || 0 ));
        obj.paidAmount = obj.StudentFee.paidAmount;
        obj.discount = obj.StudentFee.discount;
        obj.otherAmount = obj.StudentFee.OtherFee ? obj.StudentFee.OtherFee.amount : 0;
        obj.createdAt = moment(obj.createdAt).format("YYYY-MM-DD HH:MM:SS a");
        obj.activeClassGroup = obj.isActive;
        obj.studentFeeStatus = obj.StudentFee.status;
        obj.refName = obj.StudentFee.refName;
        obj.discountType = obj.StudentFee.discountType;
        return obj;
      })      
      dispatch({
        type: STUDENT_HISTORY,
        payload: studentHistoryData
      });
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const studentPaymentHistoryAction = (filters) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/paymentHistory",{params:filters});
    if (data.data.success) {
      dispatch(closeLoader());
      const studentPaymentHistoryData = data.data.data.filter(obj=>{
        obj.paymentStatus = obj.PaymentStatus.status;
        obj.payMode = obj.PaymentMode.name;
        obj.createdAt = moment(obj.createdAt).format("YYYY-MM-DD HH:MM:SS a");
        obj.paymentInfo = paymentDetailsFormatter(obj);
        obj.classGroupName = obj.StudentFee ? obj.StudentFee.ClassGroup.name : "Other Fee";
        obj.isPaymentPending = obj.payMode === CHEQUE ? ( obj.paymentInfo.isClearedCheque ? true : false ) :  true;
        console.log(obj)
        return obj;
      })      
      console.log(studentPaymentHistoryData)
      dispatch({
        type: STUDENT_PAYMENT_HISTORY,
        payload: studentPaymentHistoryData
      });
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const fetchBranchData = async(filterProperty,reqObj) => {
  console.log(filterProperty)
    return await callApi.post(`filter/${filterProperty}`,reqObj).then(res => {
      return res.data.data;
    })
    .catch(err => {
      return err;
    });;
    
};

export const upadateStudentAction = (student) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/update",student);
    if (data.data.success) {
      dispatch(closeLoader());
      const studentInfo = formatStudentDetails({...data.data.data})
      dispatch(setStudentData(studentInfo));
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const updateParentDetailsAction = (parentObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/updateParentDetails",parentObj);
    if (data.data.success) {
      dispatch(closeLoader());
      const studentInfo = formatStudentDetails({...data.data.data})
      dispatch(setStudentData(studentInfo));
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const admissionForwardClassGroupsAction = (reqObj) => async (dispatch) => {
  console.log(reqObj)
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/admissionForwardClassGroups",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      const classRoomsData = data.data.data.map(obj=> {
        obj.value =obj.id;
        obj.label = obj.name ;
        return obj;
      })
      dispatch({
        type: STUDENT_ADMISSION_FORWARD_CLASS_GROUPS,
        payload: classRoomsData,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const fetchYearsList = (reqObj) => async (dispatch) => {
  console.log(reqObj)
  try {
    dispatch(openLoader());
    const data = await callApi.post("filter/year",reqObj);
    if (data.data.success) {
      dispatch(closeLoader());
      const yearData = data.data.data.map(obj=> {
        obj.value =obj.id;
        obj.label = obj.name ;
        return obj;
      })
      dispatch({
        type: YEARS_LIST,
        payload: yearData,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const checkIfEmailExistsAction = (reqObj) => async (dispatch) => {
  console.log(reqObj)
  try {
    dispatch(openLoader());
    const data = await callApi.get("user/email_availability",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      
      dispatch({
        type: EMAIL_AVAILABILITY,
        payload: data.data.data,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const installmentsListAction = (reqObj) => async (dispatch) => {
  console.log(reqObj)
  try {
    dispatch(openLoader());
    const data = await callApi.post("payments/installments",reqObj);
    if (data.data.success) {
      dispatch(closeLoader());
      
      dispatch({
        type: INSTALLMENTS_LIST,
        payload: data.data.data,
      });
      if(data.data.data.length === 0){
          ToastMessage(SUCCESS, "Don't have any installements");
      }
      
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const deleteStudentAction = (parentObj,studentList) => async (dispatch) => {
  try {
    dispatch(openLoader());
    console.log(parentObj)
    const data = await callApi.post("student/settle_student",parentObj);
    if (data.data.success) {
      
      // const studentIndex = findIndex(studentList, function(o) { return o.id == parentObj.StudentId });
      // studentList.splice(studentIndex,1);
      // console.log(studentList)
      dispatch(closeLoader());
      // dispatch(setStudentsData({
      //   studentData: [...studentList],
      //   totalCount: studentList.length,
      //   // perPage: 0,        
      //   // totalPages: 0,
      //   // currentpage: 0
      // }));
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const resetPaymentDueAction = (filters) => async (dispatch) => {
  
      dispatch(
        {
          type: RESET_PAYMENT_DUE_LIST,
          payload: {
            studentPaymentDue: [],
            totalItems: 0,
            perPage: PER_PAGE,        
            totalPages: 0,
            currentPage: 0
          },
        });
};

export const uploadUserProfileAction = (student) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/upload_avatar",student);
    if (data.data.success) {
      dispatch(closeLoader());
      const studentInfo = formatStudentDetails({...data.data.data})
      dispatch(setStudentData(studentInfo));
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const resetStudentListAction = (filters) => async (dispatch) => {
  dispatch({
    type: RESET_STUDENTS_LIST,
    payload: [],
  });
};

export const downloadListAction = (payload) => async (dispatch) => {
 
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/downloadList",{params: payload});
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data.data)
      saveAs(data.data.data.url, data.data.data.name);
      // window.open(data.data.data, '_self');
      ToastMessage(SUCCESS, data.data.message);
      } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const dueAmountAction = (payload) => async (dispatch) => {
 
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/dueAmount",{params: payload});
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data.data)
      // if(payload.isRedirect){
      //   if(data.data.data.dueAmount > 0){
      //     dispatch(push("/dashboard"))
      //   }
      // }
      dispatch({
        type: STUDENT_DUE_AMOUNT,
        payload: data.data.data.dueAmount,
      });
      } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const resetDueAmountAction = (filters) => async (dispatch) => {
  dispatch({
    type: STUDENT_DUE_AMOUNT,
    payload: 0,
  });
};
export const openLoaderAction = (filters) => async (dispatch) => {
  dispatch(openLoader());
};
export const closeLoaderAction = (filters) => async (dispatch) => {
  dispatch(closeLoader());
};

export const fetchBloodGroupsAction = () => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/bloodgroups");
    if (data.data.success) {
      dispatch(closeLoader());
      const bloodGroups = data.data.data.map(obj=> {
        return {
          value: obj.id,
          label: obj.name
        }
      })
      dispatch({
        type: SET_BLOOD_GROUPS,
        payload: bloodGroups,
      });
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const updatePerPageAction = (filters) => async (dispatch) => {
  dispatch({
    type: UPDATE_PER_PAGE,
    payload: filters.perPage,
  });
};

export const updateChequeDetailsAction = (filters,paymentsList) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("student/updateChequeDetails",filters);
    if (data.data.success) {
      const newData =[];
       paymentsList.filter(obj=> {
        if(obj.id === filters.PaymentId){
          if(filters.chequeStatus === APPORVED){
            obj.paymentStatus = "Payment Completed"
          }else{
            obj.paymentStatus = "Payment Failed"
          }
          
          obj.isPaymentPending = true;
        }
        newData.push(obj);
      return obj;
      })
      console.log(newData)
      dispatch({
        type: STUDENT_PAYMENT_HISTORY,
        payload: newData,
      });
      dispatch(closeLoader());
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const resetRegistrationPendingAction = (data)=>({
  type: RESET_REGISTRATION_PENDING_STUDENTS,
 payload: [],
}
)

export const deletePendingRegUsers = (reqObj,studentList) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("user/delete",reqObj);
    if (data.data.success) {
      dispatch(closeLoader());
      const studentsData = studentList.filter(obj=> {
        return obj.id !== reqObj.StudentId })
        dispatch(fetchRegistrationPendingAction({
          studentData:studentsData
        }))
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};